import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';


    const styles = (theme) => ({
        root: {
          margin: 0,
          padding: theme.spacing(2),
          backroundColor: '#ffffff',
        },
        closeButton: {
          position: 'absolute',
          right: theme.spacing(1),
          top: theme.spacing(1),
        },
      });
      
      const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
      
        return (
          <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
              <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </MuiDialogTitle>
        );
      });
    
      const FindingDirectionsDialog = withStyles((theme) => ({
        paper: {
          backgroundColor: '#ffffff',
        },
        root: {
          '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '50ch',
          },
        },
    }))(Dialog);
    
    const FindingDirections = ({dialogOpen}) => {
        return (
            <>
                <FindingDirectionsDialog open={dialogOpen} aria-labelledby="customized-dialog-title" >
                    <DialogTitle id='customized-dialog-title'>
                        Loading Directions...
                    </DialogTitle>
                </FindingDirectionsDialog>
            </>
        );
};

export default FindingDirections;
